<template>
  <div class="placed-image" :class="{square: square, fill: fill}">
    <img :src="imgUrl" v-if="canView" :class="{loaded: loaded}" />
  </div>
</template>

<script>
import ViewablePanel from '@/mixins/ViewablePanel.js'
export default {
  mixins: [ ViewablePanel ],
  props: {
    url: String,
    square: Boolean,
    fill: Boolean,
    lazy: Boolean
  },
  data() {
    return {
      canView: false,
      picLoaded: false
    }
  },
  created() {
    if(!this.lazy) {
      this.canView = true
    }
  },
  computed: {
    imgUrl () {
      return this.$k.imagebase + 'mediastore/' + this.url
    },
    loaded () {
      if(!this.lazy) {
        return true
      }
      return this.picLoaded
    }
  },
  methods: {
    async loadImage() {
      await this.$k.loadImage(this.imgUrl)
      this.picLoaded = true
    }
  },
  watch: {
    seen() {
      if(this.seen && this.lazy) {
        this.canView = true
        this.loadImage()
      }
    }
  }

}
</script>

<style scoped>
.placed-image img{
  width:100%;
  display:block;
  transition:opacity 0.5s linear;
  opacity:0;
}

.placed-image img.loaded{
  opacity:1;
}

.placed-image.square{
  overflow:hidden;
  position: relative;
  min-width:100px;
}

.placed-image.fill{
  width:100%;
  height:100%;
}

.placed-image.fill img{
  min-height:100%;
  object-fit:cover;
  object-position: center center;
}



</style>
